/*============================================================================
Alle Links zu innerwise.com außer shop.innerwise.com öffnen in neuem Tab
==============================================================================*/ 

document.addEventListener('DOMContentLoaded', function() {
  // Select all 'a' elements (links)
  const links = document.querySelectorAll('a');
  
  // Loop through each link
  links.forEach(link => {
      // Check if the href contains innerwise.com but NOT shop.innerwise.com
      if (link.href && 
          link.href.includes('innerwise.com') && 
          !link.href.includes('shop.innerwise.com')) {
          // Add target="_blank" to open in new tab
          link.setAttribute('target', '_blank');
          // Add rel="noopener" for security best practices
          link.setAttribute('rel', 'noopener');
      }
  });

 /*============================================================================
Menu Drawer: bei Klic auf"Neu hier?"  das Menu schließen (notwendi das es auf Mobil dargestellt wird - ansonsten springt der Anchor link zwar im hintergrund aber ist nicht sichtbar)
==============================================================================*/ 

  // Handle menu drawer link clicks
  const menuDrawer = document.querySelector('menu-drawer');
  if (menuDrawer) {
    const menuLinks = menuDrawer.querySelectorAll('.menu-drawer__item-link');
    menuLinks.forEach(link => {
      // Only add click handler to the "Neu hier?" link
      if (link.textContent.trim() === 'Neu hier?') {
        link.addEventListener('click', () => {
          menuDrawer.hide();
        });
      }
    });
  }
});

/*============================================================================
Prüfen ob Live Webinare eingeplant sind, wenn ja, dann roten Punkt und Sichtbarkeit diverser Bereiche anpassen
==============================================================================*/

(function() {
  // Configuration
  const CONFIG = {
    endpoints: {
      webinarCollection: "/collections/online-termine/products.json"
    },
    selectors: {
      announcement: "#webinarAnnouncement",
      menuItems: ".reversed-link.mega-menu__link",
      webinarTab: '.tabs__tab[aria-controls="tab-tab_7aEcTg"]',
      collectionSection: '[id$="media_with_collection_6MXdEB"]',
      mobileMenuItem: "#webinarMobileMenuItem"
    },
    classes: {
      redDot: "red-dot"
    },
    cacheKey: "webinarDataCache",
    cacheDuration: 60 * 60 * 1000 // 1 hour in milliseconds
  };
  
  // Cache mechanism to reduce API calls
  const cache = {
    set: (key, data) => {
      const cacheData = {
        timestamp: Date.now(),
        data: data
      };
      sessionStorage.setItem(key, JSON.stringify(cacheData));
    },
    
    get: (key) => {
      const cached = sessionStorage.getItem(key);
      if (!cached) return null;
      
      try {
        const cacheData = JSON.parse(cached);
        const isExpired = (Date.now() - cacheData.timestamp) > CONFIG.cacheDuration;
        
        return isExpired ? null : cacheData.data;
      } catch (e) {
        return null;
      }
    }
  };
  
  // Helper functions
  const helpers = {
    // Toggle visibility of an element
    toggleElementVisibility: (selector, isVisible) => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (element) {
          if (selector.includes('media_with_collection')) {
            // Special handling for collection section
            element.style.visibility = isVisible ? 'visible' : 'hidden';
            element.style.opacity = isVisible ? '1' : '0';
            element.style.height = isVisible ? 'auto' : '0';
            element.style.overflow = isVisible ? 'visible' : 'hidden';
            element.style.marginTop = isVisible ? '' : '0';
            element.style.marginBottom = isVisible ? '' : '0';
            element.style.padding = isVisible ? '' : '0';
          } else {
            // Standard handling for other elements
            if (isVisible) {
              element.style.display = 'block';
              element.removeAttribute('hidden');
            } else {
              element.style.display = 'none';
              element.setAttribute('hidden', '');
            }
          }
        }
      });
    },
    
    // Add or remove red dot from menu item
    updateRedDot: (hasWebinars) => {
      const menuItems = document.querySelectorAll(CONFIG.selectors.menuItems);
      menuItems.forEach(item => {
        if (item.textContent.trim() === "Live Webinare") {
          const existingDot = item.querySelector(`.${CONFIG.classes.redDot}`);
          if (hasWebinars && !existingDot) {
            const dot = document.createElement("span");
            dot.className = CONFIG.classes.redDot;
            item.appendChild(dot);
          } else if (!hasWebinars && existingDot) {
            existingDot.remove();
          }
        }
      });
    },

    // Ensure mobile menu item stays hidden
    ensureMobileMenuItemHidden: () => {
      const mobileMenuItem = document.querySelector(CONFIG.selectors.mobileMenuItem);
      if (mobileMenuItem) {
        mobileMenuItem.style.display = 'none';
        mobileMenuItem.setAttribute('hidden', '');
        mobileMenuItem.classList.remove('animate-in');
      }
    }
  };
  
  // Main function to check collection and update UI
  async function checkCollectionAndUpdate() {
    try {
      // Try to get data from cache first
      let data = cache.get(CONFIG.cacheKey);
      
      // If no cache or expired, fetch from API
      if (!data) {
        const response = await fetch(CONFIG.endpoints.webinarCollection);
        data = await response.json();
        
        // Cache the result
        cache.set(CONFIG.cacheKey, data);
      }
      
      const hasWebinars = data.products && data.products.length > 0;
      
      // Update UI based on webinar availability
      helpers.toggleElementVisibility(CONFIG.selectors.announcement, hasWebinars);
      helpers.toggleElementVisibility(CONFIG.selectors.webinarTab, hasWebinars);
      helpers.toggleElementVisibility(CONFIG.selectors.collectionSection, hasWebinars);
      helpers.toggleElementVisibility(CONFIG.selectors.mobileMenuItem, hasWebinars);
      helpers.updateRedDot(hasWebinars);

      // Set up observer for dynamic menu loading and mobile menu visibility
      const observer = new MutationObserver(() => {
        if (!hasWebinars) {
          helpers.ensureMobileMenuItemHidden();
          helpers.updateRedDot(false);
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Additional observer for menu drawer state changes
      const menuDrawer = document.getElementById('MenuDrawer');
      if (menuDrawer) {
        const menuDrawerObserver = new MutationObserver(() => {
          if (!hasWebinars) {
            helpers.ensureMobileMenuItemHidden();
          }
        });
        
        menuDrawerObserver.observe(menuDrawer, {
          attributes: true,
          attributeFilter: ['hidden']
        });
      }
    } catch (error) {
      console.error("Error checking webinar collection:", error);
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkCollectionAndUpdate);
  } else {
    checkCollectionAndUpdate();
  }
})();



/*============================================================================
ENDE
==============================================================================*/ 